<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <form @keydown="submitted = false"
                  @submit.prevent="processForm"
                  class="form-registration form-horizontal">

                <div v-bind:class="[errors.ico ? 'has-error' : '', 'form-group']">
                    <label for="name" class="col-md-3 control-label" v-text="Lang.get('messages.form.ico')"></label>
                    <div class="col-md-9">
                        <input class="form-control"
                               type="text"
                               name="name"
                               id="name"
                               :placeholder="Lang.get('messages.form.ico')"
                               v-model="form.ico"
                               @keydown="delete errors.ico">
                        <span class="help-block"
                              v-text="errors.ico[0]"
                              v-if="errors.ico"></span>
                    </div>
                </div>

                <div v-bind:class="[errors.institution ? 'has-error' : '', 'form-group']">
                    <label for="institution" class="col-md-3 control-label" v-text="Lang.get('messages.registration.label.institution')"></label>
                    <div class="col-md-9">
                        <input class="form-control"
                               type="text"
                               name="institution"
                               id="institution"
                               :placeholder="Lang.get('messages.registration.label.institution')"
                               v-model="form.institution"
                               @keydown="delete errors.institution">
                        <span class="help-block"
                              v-text="errors.institution[0]"
                              v-if="errors.institution"
                        ></span>
                    </div>
                </div>

                <div v-bind:class="[errors.person ? 'has-error' : '', 'form-group']">
                    <label for="person" class="col-md-3 control-label" v-text="Lang.get('messages.registration.label.name')"></label>
                    <div class="col-md-9">
                        <input class="form-control"
                               type="text"
                               name="person"
                               id="person"
                               :placeholder="Lang.get('messages.registration.label.name')"
                               v-model="form.person"
                               @keydown="delete errors.person">
                        <span class="help-block"
                              v-text="errors.person[0]"
                              v-if="errors.person"></span>
                    </div>
                </div>

                <div v-bind:class="[errors.email ? 'has-error' : '', 'form-group']">
                    <label for="email_address" class="col-md-3 control-label">E-mail</label>
                    <div class="col-md-9">
                        <input class="form-control"
                               type="email"
                               name="email"
                               id="email_address"
                               placeholder="E-mail"
                               v-model="form.email"
                               @keydown="delete errors.email">
                        <span class="help-block"
                              v-text="errors.email[0]"
                              v-if="errors.email"></span>
                    </div>
                </div>

                <div v-bind:class="[errors.phone ? 'has-error' : '', 'form-group']">
                    <label for="phone" class="col-md-3 control-label" v-text="Lang.get('messages.registration.label.tel')"></label>
                    <div class="col-md-9">
                        <input class="form-control"
                               type="text"
                               name="phone"
                               id="phone"
                               :placeholder="Lang.get('messages.registration.label.tel')"
                               v-model="form.phone"
                               @keydown="delete errors.phone">
                        <span class="help-block"
                              v-text="errors.phone[0]"
                              v-if="errors.phone"></span>
                    </div>
                </div>

                <div class="form-group form-group-nm">
                    <div class="col-md-offset-3 col-md-9">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="form.subscription">
                                {{ Lang.get('messages.registration.label.subscription') }}
                            </label>
                        </div>
                    </div>
                </div>

                <div v-bind:class="[errors.terms ? 'has-error' : '', 'form-group']">
                    <div class="col-md-offset-3 col-md-9">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox"
                                       v-model="form.terms"
                                       @change="delete errors.terms; submitted = false">
                                <span v-html="Lang.get('messages.registration.label.accept')"></span>
                            </label>
                            <span class="help-block"
                                  v-text="errors.terms[0]"
                                  v-if="errors.terms">
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group form-buttons">
                    <div class="col-md-offset-3 col-md-9">
                        <button type="button" class="btn btn-primary" :disabled="submitted" v-on:click="processForm()" v-text="Lang.get('messages.registration.submit')"></button>
                        <a class="btn btn-default" href="/" v-text="Lang.get('messages.form.back')"></a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert';

    export default {
        data() {
            return {
                form: {
                    ico: this.ico,
                    institution: this.institution,
                    person: this.person,
                    email: this.email,
                    phone: this.phone,
                    subscription: this.subscription,
                    terms: this.terms
                },
                submitted: false,
                errors: {},
            }
        },

        methods: {
            processForm() {
                this.submitted = true;

                axios.post(Lang.get('url.signup'), this.form)
                    .then(() => {
                        swal(Lang.get('messages.registration.finished'), Lang.get('messages.registration.finished.desc'), 'success', { button: Lang.get('messages.form.back') })
                            .then(function () {
                                window.location = '/';
                            })
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                    });
            }
        }
    }
</script>

<style scoped>
    form.form-registration {
        margin-top: 40px;
    }
    form.form-registration .has-error {
        margin-bottom: 15px;
    }
    form.form-registration .form-group-nm {
        margin-bottom: 0px;
    }
    @media (min-width: 1200px) {
        form.form-registration input[type=checkbox] {
            margin-top: -3px;
        }
    }
</style>
